import request from '@/utils/request'

/**
 * 获取工艺设备页面所有公开数据
 */
export function getPublicEquipmentAll() {
  return request({
    url: '/cms/equipment/public/all',
    method: 'get'
  })
}
